import React, { useEffect, useState } from 'react';
import '../styles/Spinner.css';

// Props du composant Spinner
type SpinnerProps = {
    spinnerContent: string[];
    initialIndex: number;
    setSpinnerFinalValue: (value: string) => void;
    isWrong: boolean;
};

// Composant Spinner avec boutons pour faire défiler les options
const Spinner: React.FC<SpinnerProps> = ({
    spinnerContent,
    initialIndex = 0,
    setSpinnerFinalValue,
    isWrong = false,
}) => {
    const [currentIndex, setCurrentIndex] = useState(initialIndex);

    // Fonctions pour naviguer dans le spinner
    const moveToNext = () => {
        if (!spinnerContent) return;
        setCurrentIndex((prevIndex) => {
            const newIndex = (prevIndex + 1) % spinnerContent.length;
            return newIndex;
        });
    };
    const moveToPrevious = () => {
        if (!spinnerContent) return;
        setCurrentIndex((prevIndex) => {
            const newIndex = (prevIndex - 1 + spinnerContent.length) % spinnerContent.length;
            return newIndex;
        });
    };

    // Met à jour la valeur finale à chaque changement d'index
    useEffect(() => {
        if (spinnerContent.length && setSpinnerFinalValue) {
            setSpinnerFinalValue(spinnerContent[currentIndex]);
        }
    }, [currentIndex]);

    return (
        <div className='spinner-container'>
            <img
                src='./images/button-polygon.png'
                alt='Spinner button up'
                className='spinner-wheel spinner-up'
                onClick={moveToNext}
            />
            {spinnerContent && (
                <div className='spinner-content'>
                    <p
                        key={currentIndex}
                        className={`code-page-spinner-text-${isWrong ? 'wrong' : 'correct'}`}
                    >
                        {spinnerContent[currentIndex]}
                    </p>
                </div>
            )}
            <img
                src='./images/button-polygon.png'
                alt='Spinner button down'
                className='spinner-wheel spinner-down'
                onClick={moveToPrevious}
            />
        </div>
    );
};

export default Spinner;
